import { LandingTranslationType } from "../../features/landing.types";

export const landing: LandingTranslationType = {
  landing: {
    hero: {
      title: "اصنع قصتك مع الذكاء الاصطناعي",
      subtitle: "حيث يلتقي الخيال بالذكاء الاصطناعي",
      description: "استخدم منصتنا التفاعلية للرواية القصصية المدعومة بالذكاء الاصطناعي لإنشاء قصص وشخصيات جذابة",
      startStory: "ابدأ قصتك",
      signIn: "تسجيل الدخول"
    },
    features: {
      title: "أطلق العنان لإبداعك",
      aiPowered: {
        title: "قصص مدعومة بالذكاء الاصطناعي",
        description: "أنشئ روايات فريدة مع محرك سرد القصص المتقدم بالذكاء الاصطناعي"
      },
      interactiveChoices: {
        title: "خيارات تفاعلية",
        description: "شكّل قصتك من خلال قرارات هادفة وإجراءات مخصصة"
      },
      creativeFreedom: {
        title: "حرية إبداعية",
        description: "اكتب مسارك الخاص مع إمكانيات إبداعية لا حدود لها"
      }
    },
    preview: {
      title: "معاينة قصة",
      storyText: "صرّ الباب القديم وهو يُفتح، كاشفاً عن غرفة تغمرها إضاءة زرقاء أثيرية. برزت تشكيلات كريستالية من الجدران، تعكس أسطحها أقواس قزح صغيرة لا تحصى عبر الغرفة. في المركز، يطفو على بعد بوصات فوق قاعدة من الرخام الأسود، كتاب مجلد بما يبدو أنه ضوء النجوم نفسه...",
      whatToDo: "ماذا تفعل؟",
      choice1: "اقترب من الكتاب بحذر، وادرس الغرفة بحثاً عن الفخاخ",
      choice2: "استخدم سحرك لاستشعار أي تعاويذ خطيرة",
      choice3: "اقبض على الكتاب بجرأة - الحظ يحالف الشجعان!"
    },
    storyPreview: {
      header: "استمتع برواية القصص الغامرة",
      description: "أنشئ واستكشف وشكل القصص في بيئة تفاعلية ديناميكية مع {{appName}}",
      genres: "الأنواع",
      themes: "المواضيع",
      environment: "البيئة",
      writeResponse: "اكتب ردك الخاص...",
      previousStory: "القصة السابقة",
      nextStory: "القصة التالية",
      goToStory: "انتقل إلى القصة {{number}}"
    },
    callToAction: {
      title: "هل أنت مستعد لبدء رحلتك؟",
      subtitle: "انضم إلى آلاف رواة القصص الذين يبتكرون مغامرات فريدة مع الذكاء الاصطناعي",
      button: "ابدأ الكتابة الآن"
    },
    creativeSuite: {
      title: "مجموعة الإبداع",
      description: "أدوات قوية لإطلاق إمكانات رواية القصص لديك وإحياء خيالك",
      categories: {
        stories: "القصص",
        characters: "الشخصيات",
        premium: "المميز"
      },
      premiumFeature: "ميزة مميزة",
      basicFeature: "متاح في الخطة الأساسية",
      freeFeature: "مجاني للجميع",
      getStarted: "ابدأ الآن",
      noCreditCard: "لا حاجة لبطاقة ائتمان لبدء رحلتك الإبداعية",
      tools: {
        aiWriting: {
          title: "كتابة بالذكاء الاصطناعي",
          description: "أنشئ قصص اختر مغامرتك الخاصة مع ذكاء اصطناعي متقدم. تقدم مع إجابات مقترحة أو اكتب ردودك الخاصة."
        },
        genresThemes: {
          title: "أنواع وموضوعات وبيئات واسعة",
          description: "كمستخدم مجاني، يمكنك الوصول إلى مجموعة محدودة من الأنواع، أو فتح جميع الأنواع والموضوعات مع الخطة الأساسية."
        },
        sequels: {
          title: "تكملات وسلسلة القصص",
          description: "واصل أفضل قصصك مع تكملات وابني سلسلة قصص جذابة."
        },
        characterBuilder: {
          title: "منشئ الشخصيات",
          description: "صمم شخصيات معقدة مع شخصيات مفصلة ودوافع وقصص خلفية."
        },
        aiPortraits: {
          title: "صور شخصيات بالذكاء الاصطناعي",
          description: "أنشئ تمثيلات بصرية فريدة لشخصياتك مع مولد الصور بالذكاء الاصطناعي لدينا."
        },
        characterExtract: {
          title: "استخراج الشخصيات",
          description: "استخرج الشخصيات من قصصك تلقائيًا لبناء مكتبة شخصياتك."
        },
        sharing: {
          title: "مشاركة ونشر القصص",
          description: "شارك قصصك واجعلها عامة ليستمتع بها الآخرون ويقدرونها."
        },
        unlimitedStorage: {
          title: "زيادة حد القصص",
          description: "أنشئ حتى 5 قصص يوميًا مع الخطة المجانية، و25 مع الخطة الأساسية، أو قصص غير محدودة مع الخطة المميزة."
        },
        statsBadges: {
          title: "إحصائيات وشارات",
          description: "تتبع إحصائيات الكتابة الخاصة بك واكسب شارات لإنجازات رواية القصص الخاصة بك."
        }
      }
    },
    exampleStories: {
      dragonsRiddle: {
        title: "لغز التنين",
        excerpt: "طرح التنين القديم لغزاً ظل بلا حل لقرون. \"أجب بشكل صحيح،\" زمجر، \"وسأمنحك المرور عبر الجبل.\" تلألأت حراشف المخلوق الهائل مثل الأوبسيديان في ضوء الكهف الخافت. وقفت هناك، وأطراف أصابعي ترتجف على الحجر البارد، ورفاقي متجمدين خلفي. عيون التنين العنبرية ثبتت على عينيّ. \"ولكن إذا فشلت،\" واصل الوحش، \"ستنضم إلى عظام من سبقوك.\" أشار إلى بقايا متناثرة حاولت ألا ألاحظها. كانت التنانين مولعة بألعاب الكلمات والمعاني الخفية. كان مصير مهمتنا يعتمد على قدرتي على فك شفرة لغز المخلوق.",
        suggestion1: "\"الإجابة هي 'الوقت' - يلتهم كل شيء، لكنه لا يُستهلك أبداً،\" أعلنت بثقة أكبر مما شعرت به.",
        suggestion2: "انحنيت باحترام للوحش القديم. \"أيها العظيم، هل يمكنني طرح سؤال توضيحي حول لغزك؟\"",
        suggestion3: "نظرت إلى وجوه رفاقي الخائفة قبل أن أعود إلى التنين. \"ربما يمكننا التفاوض على طريق آخر للعبور؟\""
      },
      echoesFromTomorrow: {
        title: "أصداء من الغد",
        excerpt: "حدقت الدكتورة ميراندا تشين في الرسالة على شاشتها. وصلت بالأمس، لكن الطابع الزمني أظهر أنها أُرسلت غداً. قرأتها مرة أخرى: \"بروتوكول أوميغا مُفعّل. لا تواصل تسلسل الاختبار. انهيار زمني كارثي وشيك.\" تحققت ميراندا من مصفوفة الاتصال الكمي التي صممتها - كانت مخصصة لتقليل تأخير الإشارة، لا لاختراق الحجاب بين الحاضر والمستقبل. تطابقت التوقيعات الكمية المضمنة في الرسالة مع بروتوكولات التشفير الخاصة بهم بالضبط، مع شذوذ واحد مستحيل: أظهرت أنماط تحلل لا يمكن أن توجد بعد. بينما رنّ جهازها بإشعار رسالة واردة أخرى، شعرت ميراندا بقشعريرة. عرض معرف المرسل اسمها هي.",
        suggestion1: "كتبت ميراندا بسرعة: \"هنا الدكتورة تشين. عرّف بنفسك واشرح كيف تصل إلى أنظمتنا الآمنة.\"",
        suggestion2: "بدأت إغلاقاً طارئاً بينما كانت تنسخ احتياطياً جميع بيانات المشروع إلى الخادم الخارجي الآمن.",
        suggestion3: "اتصلت بشريكها في البحث: \"كينجي، شيء مستحيل يحدث مع المصفوفة الكمية.\""
      },
      forgottenLibrary: {
        title: "المكتبة المنسية",
        excerpt: "كانت المكتبة تظهر فقط في الليالي الممطرة، تفتح أبوابها لمن هم في أمسّ الحاجة للإجابات. كنت أبحث عنها لسنوات، متتبعاً الشائعات والإشارات الغامضة. الآن، وبينما وقفت أمام هندستها المستحيلة - أكبر من الداخل مما هي عليه من الخارج - ترددت. كانت أبواب البلوط الضخمة مفتوحة قليلاً، والضوء الدافئ ينسكب على الأحجار المبللة. ارتفعت قاعة المدخل بشكل لا يصدق، والرفوف تمتد إلى ما وراء المكان الذي يفترض أن يكون فيه السقف. كانت رائحة الهواء من ورق، وحبر، وشيء أقدم - كما لو أن للزمن نفسه رائحة. لاحظت أن الهمسات تزداد قوة، قادمة من آلاف الكتب تتحدث في وقت واحد. ثم، ارتفع صوت فوق البقية: \"كنا ننتظرك.\"",
        suggestion1: "\"من هناك؟\" صرخت، وصوتي يتردد عبر الفضاء الشاسع بينما كنت أتفحص الممرات المظلمة.",
        suggestion2: "اقتربت من أقرب رف ومررت أصابعي على الأغلفة القديمة، متسائلاً أي كتاب قد تحدث.",
        suggestion3: "\"لقد جئت بحثاً عن معلومات حول التقارب السماوي،\" أعلنت للمكتبة الهامسة."
      }
    }
  }
};
